export default function autoRefresh() {
    if (document.querySelector('*[data-component="product"]')) {
        const pageLoadedTimestamp = Date.now() / 1000;
        const dayInSeconds = 86400;
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                if (pageLoadedTimestamp + dayInSeconds < Date.now() / 1000) {
                    window.location.reload();
                }
            }
        }, false);
    }
}
